import { API_BASE, ENVIRONMENT } from '../../../config/env';
import { httpConstants } from '../../../constants';
import { httpService } from '../../../utility/httpService';
import { EvaluateApiResponse, FileUploadResponse, UploadedFile } from './uploaderTypes';

export async function uploadFile(file: File): Promise<FileUploadResponse | undefined> {
  const formData = new FormData();
  formData.append('upload', file, file.name);

  try {
    const response = await httpService<FileUploadResponse>(
      httpConstants.METHOD_TYPE.POST,
      `${API_BASE}/api/data-xplr/nexus/files`,
      formData
    );
    return response;
  } catch (error) {
    console.error('Failed to upload file:', error);
    return undefined;
  }
}

export async function evaluateFiles(files: UploadedFile[]): Promise<EvaluateApiResponse[]> {
  let filesData = files?.map((file: UploadedFile) => {
    return {
      env: ENVIRONMENT,
      id: file?.id,
      fileName: file?.name,
      fileUrl: file?.filePath,
    };
  });

  try {
    const response = await httpService<any>(
      httpConstants.METHOD_TYPE.POST,
      `${API_BASE}/api/v1/enterprise-technology/context-extracted/`,
      { files: filesData },
      undefined,
      true
    );
    return response ?? [];
  } catch (error) {
    console.error('Failed to upload file:', error);
    return [];
  }
}

export async function uploadEvaluatedData(payload: any): Promise<FileUploadResponse | undefined> {
  try {
    const response = await httpService<any>(
      httpConstants.METHOD_TYPE.POST,
      `${API_BASE}/api/v1/enterprise-technology/custom-file/bulk/`,
      payload,
      undefined,
      true
    );
    return response;
  } catch (error) {
    console.error('Failed to upload file:', error);
    return undefined;
  }
}

export async function updateTechLandscape(payload: any): Promise<FileUploadResponse | undefined> {
  console.log('enterpriseData', payload);

  try {
    const response = await httpService<any>(
      httpConstants.METHOD_TYPE.POST,
      `${API_BASE}/api/v1/enterprise-technology/update-tech-landscape/`,
      payload,
      undefined,
      true
    );
    return response;
  } catch (error) {
    console.error('Failed to upload file:', error);
    return undefined;
  }
}

export async function getLicenseUploadStatus(): Promise<FileUploadResponse | undefined> {
  try {
    const response = await httpService<any>(
      httpConstants.METHOD_TYPE.GET,
      `${API_BASE}/api/v1/enterprise-technology/custom-file/by-organization/`
    );
    return response;
  } catch (error) {
    console.error('Failed to upload file:', error);
    return undefined;
  }
}

export async function deleteLicenseFile(
  id: string,
  fileId: string
): Promise<FileUploadResponse | undefined> {
  try {
    const payload = {
      id: id,
      file_id: fileId,
    };
    const response = await httpService<any>(
      httpConstants.METHOD_TYPE.POST,
      `${API_BASE}/api/v1/enterprise-technology/custom-file/delete/`,
      payload,
      undefined,
      true
    );
    return response;
  } catch (error) {
    console.error('Failed to upload file:', error);
    return undefined;
  }
}

export async function saveKnowledgeBase(
  payload: Record<string, any>
): Promise<FileUploadResponse | undefined> {
  try {
    const response = await httpService<any>(
      httpConstants.METHOD_TYPE.POST,
      `${API_BASE}/api/v1/enterprise-technology/custom-file/`,
      payload,
      undefined,
      true
    );
    return response;
  } catch (error) {
    console.error('Failed to upload file:', error);
    return undefined;
  }
}
